<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small" style='border: none;'>
        <div class="content-name">
          <h2 class="dp-ib">{{title}} 보기</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="warning" icon="el-icon-document-copy" @click="goList" >목록</el-button>
            <el-button v-if="grantUpdate == 'Y' || authority" type="primary" icon="el-icon-document-add" @click="goModify" >수정</el-button>
            <el-button v-if="(grantDelete == 'Y' || authority) &&  sampleFlag " type="danger" icon="el-icon-delete" ref="deleteBtn" @click="deleteValidate">삭제</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-form ref="form" :model="form" size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="80px" label="제목">
              <el-input v-model="form.docNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1"><span></span></el-col>
          <el-col :span="4">
            <el-form-item label-width="80px" label="조회수">
              <el-input v-model="form.readCnt" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="100px" label="확인자수">
              <el-input v-model="form.confirmCnt" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="80px" label="이름">
              <el-input v-model="form.creatorNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="80px" label="작성일자">
              <el-input v-model="form.createDtText" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="(srcId2 === 'Notice' &&($store.state.loginInfo.groupUId === 1 || $store.state.loginInfo.groupUId === 2)) || srcId3 === 'Praise' ">
          <el-col :span="24" style="padding: 0; margin-bottom: 5px;">
            <el-select
                style="width: 100%;"
                v-model="form.asAgentsList"
                disabled="disabled"
                multiple>
              <el-option
                  v-for="item in agentList"
                  :key="item.asAgentId"
                  :label="item.asAgentNm"
                  :value="item.asAgentId"/>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="14">
            <el-col :span="12">
              <el-form-item label-width="100px" label="공지기간">
                <el-input v-model="form.startDtText" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1" style="text-align: center;">-</el-col>
            <el-col :span="8">
              <el-form-item label-width="0px">
                <el-input v-model="form.endDtText" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="10">
            <el-form-item label-width="80px" label="중요도">
              <el-input v-model="form.importanceText" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="ck-editor">
              <ckeditor id="readEdit"
                        :editor="editor"
                        v-model="form.html"
                        :config="editorConfig"
                        @ready="onEditorReady"
                        @focus="onEditorFocus"
                        @blur="onEditorBlur"
                        @input="onEditorInput"
                        @destroy="onEditorDestroy"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="this.srcId2 == 'Notice' && this.srcId3 == 'Importance'">
          <el-col :span="10">
            <el-form-item label="관련 모델" label-width="70px">
              <el-input v-model="form.modelNm" readonly></el-input>
              <el-input v-model="form.modelId" v-show="false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item
                label="첨부파일"
                label-width="10"
            >
              <el-upload
                  disabled
                  action=""
                  class="upload-demo"
                  :file-list="fileList"
                  :on-preview="fileDownload"
                  :on-change="handleChange"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!--        <el-row :gutter="24">-->
        <!--          <el-col :span="10">-->
        <!--            <el-form-item-->
        <!--                label="이미지"-->
        <!--                label-width="10"-->
        <!--            >-->
        <!--              <el-upload-->
        <!--                  disabled-->
        <!--                  :file-list="imageList"-->
        <!--                  class="upload-demo"-->
        <!--                  action="#"-->
        <!--                  :on-change="handleChange"-->
        <!--              />-->
        <!--              <el-dialog>-->
        <!--                <img w-full :src="dialogImageUrl" alt="Preview Image" />-->
        <!--              </el-dialog>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->

      </el-form>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-button type="primary" icon="el-icon-document-add" @click="goComment" style="float: right; z-index: 1; position: relative;">확인</el-button>
            <el-form-item label="댓글">
              <el-input type="textarea" v-model="cForm.html" rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="el-table-tree">
        <el-table
            size="mini"
            border
            default-expand-all
            :data="commentData"
            row-key="id"
            style="width: 100%">
          <!--          <el-table-column-->
          <!--              type="index"-->
          <!--              :index="indexMethod">-->
          <!--          </el-table-column>-->
          <el-table-column
              prop="creatorNm"
              label="작성자"
              width="180">
          </el-table-column>
          <el-table-column
              prop="content"
              label="내용">
          </el-table-column>
          <el-table-column
              prop="createDt"
              label="작성일"
              sortable
              :formatter="dateFormatter"
              width="180">
          </el-table-column>
          <el-table-column
              v-if="authority"
              label="삭제"
              width="100">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  type="danger"
                  @click="deleted(scope.$index, scope.row)">삭제</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import _ from "lodash";
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer'
import AgGridScanAttach from "@/components/agGrid/AgGridScanAttach";

export default {
  name:'boardMngRead',
  //props:['custParam','title'],
  props: {
    custParam: {
      Type: Object,
      required: true,
    },
    title: {
      Type: String,
      required: true,
    },
  },
  data(){
    return {
      // title:'',
      editor: ClassicEditor,
      editorData: '<p> 에디터에 데이터를 입력하세요. </p>',
      editorConfig: {
        language: 'en',
      },
      writeGrant: false,
      sampleFlag: true,
      agentList:[],
      gridOptions: {
        // onColumnResized: true,
        // enableFilter: true,
        // enableSorting: true,
        // suppressRowTransform: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        //editable: true
      },
      gridApi : null ,    //gridAip
      columnApi : null ,  //columApi
      columnComment: [] ,    //comulum Defs
      boardId:'',
      commentData:[],
      grantDelete : '',
      grantInsert : '',
      grantSelect : '',
      grantUpdate : '',
      // boardInfo:{},
      form:{
        asAgentsList: [],
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDt : "",
        createDtText : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : "",
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "",
        noticeYn : "",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "",
        srcId2 : "",
        srcId3 : "",
        srcId4 : "",
        startDt : "",
        startDtText : "",
        updateDt : "",
        updatorId : "",
        modelId : "",
        modelNm : "",
      },
      cForm :{
        commentId : "",
        commentNm : "",
        html : "",
        cotent : "",
      },
      defForm:{
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDtText : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : "",
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "",
        noticeYn : "Y",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "",
        srcId2 : "",
        srcId3 : "",
        srcId4 : "",
        startDt : "",
        startDtText : "",
        asAgentId : "",
        updateDt : "",
        updatorId : "",
        modelId : "",
        modelNm : "",
      },
      defCForm :{
        commentId : "",
        commentNm : "",
        html : "",
        cotent : "",
      },
      admin:{
        id:'',
        boardCd:'',
        boardSubCd:'',
        bSubject:'답변',
        bContent:'',
        attribute1:'',
        attribute2:'',
        attribute3:'',
        bReply:'N'
      },
      frameworkComponents: {
        AgGridScanAttach: AgGridScanAttach,
      },
      adminR:[],
      resp:'',
      fileList:[],
      imageList:[],
      editorOptions : {
        theme:'bubble'
      }
    }
  },
  computed: {
    authority() {
      // return this.$store.state.loginInfo.id === this.form.creatorId || this.$store.state.loginInfo.groupUId === 2;
      return this.$store.state.loginInfo.id === this.form.creatorId;
    }
  },
  created(){
    //this.boardInfo = this.$route.params.boardInfo;
    //this.title = this.this.$route.params.title;
  },
  beforeMount() {
    this.getParameter();
  },
  mounted(){

    this.setInfo();
    this.getAgentList();
    this.getFileList();
    this.getImageList();
    this.getCommentList();
    this.createColumnComment();
    this.chkGrant();
    this.chkSample();
    this.isAuth();

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      buttonCellRenderer: ButtonCellRenderer,
    };

  },
  methods:{
    chkGrant(){
      // 기술,일반 공지 게시판은 시스템,관리자 권한 가진 유저만 글쓸 수 있도록
      if(this.srcId2 == 'Notice' && (this.srcId3 == 'Normal' || this.srcId3 == 'Importance' )){
        if(this.$store.state.loginInfo.groupUId == 1 || this.$store.state.loginInfo.groupUId == 2) this.writeGrant = true;
      }else{
        this.writeGrant = true;
      }
    },
    getParameter(){
      this.parameter = this.$menu.getGrants().parameter?.split("&");
      this.srcId1 = this.parameter[0]?.substring(this.parameter[0]?.indexOf('=')+1); // 콜센터,센터 구분
      this.srcId2 = this.parameter[1]?.substring(this.parameter[1]?.indexOf('=')+1); // 공지,일반 구분
      this.srcId3 = this.parameter[2]?.substring(this.parameter[2]?.indexOf('=')+1); // 게시판 종류 구분
    },
    getAgentList(){
      // this.$http.post(`/api/boardMng/agent/list`,{
      //   companyId: this.$store.state.loginInfo.compCd,
      //   siNm: "",
      //   guNm: "",
      //   dongNm: "",
      //   statusYn: "Y",
      //   processTime : ""
      // })
      // .then(response => {
      //   this.agentList = response.data;
      // }).finally(() => {
      //   this.$store.commit('finish')
      // });

      this.$http.post(`/api/boardMng/area/agent/list`)
          .then(res => res.data)
          .then(data => {
            this.agentList = data;
            this.agentList.unshift({asAgentId: 9999, asAgentNm: '전체'});
            if(this.agentList.length - 1 === this.form.asAgentsList.length) {
              this.form.asAgentsList = [9999];
            }
          }).finally(() => {
            this.$store.commit('finish')
          });

    },
    goComment(){

      this.cForm.content =  this.cForm.html.replace(/<[^>]*>?/g, '');

      this.$http
          .put('/api/boardMng/comment/save',{
            companyId: this.$store.state.loginInfo.compCd,
            srcId1: 'DOC',
            srcId2: this.form.docId,
            srcId3: '',
            srcId4: '',
            mark: 0,
            commentNm: '',
            content: this.cForm.content,
            html: this.cForm.html,
            creatorNm : this.$store.state.loginInfo.userName,
            pwd: '',
            creatorId: this.$store.state.loginInfo.id,
            processTime: "",
            commentId:0
          })
          .then(response => {
            // this.$swal({ type: 'success', text: '저장되었습니다.' });
            this.cForm = _.clone(this.defCForm);
            this.getCommentList();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    //컬럼정의 함수
    createColumnComment() {
      const vm = this;

      this.columnComment = [
        {
          headerName: '작성자',
          width : 250 ,
          field: 'creatorNm',
          cellStyle:{textAlign: 'center'}
        },
        {
          headerName: '작성일'
          , width : 400
          , field: 'createDt'
          , cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {
          headerName: '내용',
          width : 1200 ,
          field: 'content',
          cellStyle:{textAlign: 'left'}
        },
        {
          headerName: '',
          width : 150 ,
          field : 'del',
          editable: false,
          cellRenderer: 'buttonCellRenderer',
          cellRendererParams: {
            name: '삭제'
          }
        },
      ]
    },
    indexMethod(index) {
      return ++index;
    },
    dateFormatter(row, column) {
      return this.$moment(row.date).format('yyyy-MM-DD HH:mm:ss')
    },
    deleted(index, row) {


      this.$http
          .put('/api/boardMng/comment/delete',{
            companyId: this.$store.state.loginInfo.compCd,
            commentId: row.commentId,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '삭제되었습니다.' });
            this.getCommentList();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    handleChange(uploadFile, uploadFiles) {
      this.fileList.value = this.fileList.value.slice(-3)
    },
    getCommentList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/comment/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        sortType : true,
        page : 1,
        totalPage : 9999,
        totalCount : 9999,
        curPage : 0,
        processTime : ""
      })
          .then(response => {
            this.commentData = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    getFileList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/file/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        processTime : ""
      })
          .then(response => {
            this.fileList = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    getImageList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/image/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        processTime : ""
      })
          .then(response => {
            this.imageList = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    goList(){
      this.cancel();
      this.viewType = 'list';
      this.$emit('viewType');
    },
    goModify(){
      this.$prompt(this.$store.state.loginInfo.groupUId !== 2 ? '비밀번호를 입력해주세요.' : '수정하시겠습니까?', '확인', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showInput: this.$store.state.loginInfo.groupUId !== 2,
        inputType: 'password',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if(instance.inputValue === this.form.pwd) {
              done();
            } else {
              if(this.$store.state.loginInfo.groupUId !== 2) {
                this.$message({
                  type: 'error',
                  message: instance.inputValue ? '비밀번호가 틀렸습니다.' : '비밀번호를 입력해주세요.'
                });
              } else {
                this.viewType = 'modify';
                this.$emit('viewType');
                done();
              }
            }
          } else {
            done();
          }
        }
      }).then(({action}) => {
        if(action === 'confirm') {
          this.viewType = 'modify';
          this.$emit('viewType');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '취소 되었습니다.'
        });
      });
    },
    goRefresh(){
      this.cancel();
      this.viewType = 'list';
      this.$emit('refresh');
    },
    cancel(){
      // CatInfo 초기화
      this.form = _.clone(this.defForm);
      this.$parent.custParam = this.form;
    },
    goDeleted(){

      let submitList = []

      submitList.push({
        docId:this.form.docId
      });

      this.$http
          .put('/api/boardMng/delete',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: response.data });
            this.goRefresh();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    deleteValidate() {

      this.$prompt(this.$store.state.loginInfo.groupUId !== 2 ? '비밀번호를 입력해주세요.' : '삭제하시겠습니까?', '확인', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showInput: this.$store.state.loginInfo.groupUId !== 2,
        inputType: 'password',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if(instance.inputValue === this.form.pwd) {
              done();
            } else {
              if(this.$store.state.loginInfo.groupUId !== 2) {
                this.$message({
                  type: 'error',
                  message: instance.inputValue ? '비밀번호가 틀렸습니다.' : '비밀번호를 입력해주세요.'
                });
              } else {
                this.goDeleted()
                done();
              }
            }
          } else {
            done();
          }
        }
      }).then(({action}) => {
        if(action === 'confirm') {
          this.goDeleted()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '취소 되었습니다.'
        });
      });
    },
    typeSwitch(type){
      switch (type){
        case 'Normal':
          return type ='일반공지';
        case 'Importance':
          return type ='기술공지';
        case 'Quality':
          return type ='품질정보서';
        case 'ProductChange':
          return type ='제품교환';
        case '일반공지사항':
          return type ='Normal';
        case '기술공지사항':
          return type ='Importance';
        case '품질정보서게시판':
          return type ='Quality';
        case '제품교환게시판':
          return type ='ProductChange';
      }
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    chkSample(){
      if(this.form.docId == 23332 || this.form.docId == 23333) this.sampleFlag = false; // 양식이 되는 게시물은 삭제 할 수 없게
    },
    fileDownload(file){
      this.$store.commit('loading')

      this.$http.get(`/api/v1/download/board/${file.storeName}/${file.fileId}`,{ responseType: 'blob' })
        .then((response) => {
            //back-end local header config path 실제 존재 경로에서 가져온 데이터를 그대로 세팅.
            let link = document.createElement('a');
            link.href = response.config.url;

            link.setAttribute('download', file.name);

            document.body.appendChild(link);
            link.click();
            //아래 소스 사용시 해당 파일의 실제 경로는 못찾아 손상된 파일로 데이터 생성되어짐.
            // const downloadedfile = new Blob([response.data], { type: response.headers['content-type'] });

            // const contentDisposition = response.headers['content-disposition'];

            // let fileName = 'unknown';
            // if (contentDisposition) {
            //   const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            //   if (fileNameMatch.length === 2)
            //     fileName = fileNameMatch[1];
            // }

            // if (window.navigator.msSaveOrOpenBlob) {
            //   window.navigator.msSaveOrOpenBlob(downloadedfile, fileName);
            // } else {
            //   const url = window.URL.createObjectURL(downloadedfile);

            //   let link = document.createElement('a');
            //   link.href = url;

            //   link.setAttribute('download', file.name);

            //   document.body.appendChild(link);
            //   // link.click();
            // }

        }).catch(response => {
          console.log("catch response" , response)
        }).finally(()=> {
          this.$store.commit('finish');
        });
    },
    addReply(){
      // if(!this.admin.bContent){
      //     this.$swal({type: 'warning', text: '내용을 입력해 주세요.'});
      //     return false;
      // }
      // this.form.bReply='Y'
      // this.$http.put(`/api/board/updateBoardDetail/${this.form.id}`, this.form)
      //
      // this.$http.post(`/api/board/addBoard`, this.admin)
      // .then(response=>{
      //     console.log("댓글 저장")
      //     this.resp = response.data;
      //     this.$swal({
      //         type: 'success',
      //         text: '댓글 등록완료.'
      //     }).then(() => {
      //         this.$router.push({
      //             name: 'ListSuggest',
      //         })
      //     })
      // })
    },
    onEditorReady(eventInfo) {
      eventInfo.editing.view.change((writer)=> {
        writer.setStyle("height", "400px", eventInfo.editing.view.document.getRoot())
      });
      eventInfo.enableReadOnlyMode("#readEdit",true)
      const toolbarElement = eventInfo.ui.view.toolbar.element; //toolbar element 객체 담기
      toolbarElement.style.display = "none"; //해당 객체 display none 처리
    },
    onEditorFocus(eventInfo, data ) {
      // console.log('onEditorFocus', eventInfo, data);
    },
    onEditorBlur(eventInfo, data ) {
      // console.log('onEditorBlur', eventInfo, data);
    },
    onEditorInput(eventInfo, batch) {
      // console.log('onEditorInput', eventInfo, batch);
      //Corresponds to the change:data editor event. See the v-model directive to learn more.
    },
    onEditorDestroy(eventInfo) {
      // console.log('onEditorDestroy', eventInfo);
    },
    setInfo() {
      Object.assign(this.form, this.custParam);
      this.form.importanceText = this.typeSwitch(this.form.importance);
      this.form.startDtText = this.getDateFormat(this.form.startDt);
      this.form.endDtText = this.getDateFormat(this.form.endDt);
      this.form.createDtText = this.getDateFormat(this.form.createDt);
    },
    isAuth(){
      this.auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===this.$menu.getGrants().programId); // 설치내역 팝업
      const auth = this.auth

      this.grantDelete = auth[0].grantDelete;
      this.grantInsert = auth[0].grantInsert;
      this.grantSelect = auth[0].grantSelect;
      this.grantUpdate = auth[0].grantUpdate;
      this.grantExtend1 = auth[0].grantExtend1;
      this.grantExtend2 = auth[0].grantExtend2;
    }
  },
  watch: {
    custParam() {
      this.setInfo();
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input.is-disabled .el-input__inner {
  background-color: white;
}
.el-upload{
  display: none !important;
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px;
  border-radius: 5px;
}
.el-row {
  border-bottom: 1px solid #d7d7d7;
  margin-top: 7px;
}
</style>